<template>
    <div>
        <tab name="5"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchName1" class="input-with-select" size="small">
                        <el-select v-model="params.searchType1" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                            <el-option label="艺人ID" :value="3"></el-option>
                            <el-option label="艺人名称" :value="4"></el-option>
							<el-option label="项目负责人" :value="5"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <!-- <el-select v-model="params.showTypeTagIds" filterable multiple collapse-tags placeholder="请选择活动类型" size="small">
                        <el-option
                            v-for="item in showTypeTagList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select> -->
                    <el-cascader v-model="params.showTypeTagIds" collapse-tags :options="showTypeTagList" :props="{multiple:true, value:'id',label:'name',children:'tags', emitPath:false}" placeholder="不限制活动类型" size="small" style="width:100%"></el-cascader>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.siteTypeTagIds" filterable multiple collapse-tags placeholder="请选择场地类型" size="small">
                        <el-option
                            v-for="item in siteTypeTagList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">                    
					<div class="clearfix timeType">
					    <el-input class="input-with-select fl" size="small">
					        <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
					            <el-option label="下单时间" :value="1"></el-option>
					        </el-select>
					    </el-input>
					    <el-date-picker
                        v-model="params.time"
					        type="datetimerange"
					        range-separator="-"
					        start-placeholder="开始时间"
					        end-placeholder="结束时间"
					        size="small"
					        value-format="yyyy-MM-dd HH:mm:ss"
					        :default-time="['00:00:00', '23:59:59']"
					        :clearable="false"
					        popper-class="el-date-picker_clearable"
					        style="width: 100%;"
					        unlink-panels
					        >
					    </el-date-picker>
					</div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示实际收入最多的" :value="1"></el-option>
                        <el-option label="优先展示总订单数最多的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="exportData" :loading="exportDataLoading" :disabled="!filter" icon="el-icon-download">导出</el-button>
            <el-button  type="primary"  size="small" @click="viewChart" :disabled="!filter" icon="el-icon-data-analysis">查看图表</el-button>
        </div>
        <template v-if="statistics">
            <div class="page-group-title"><span>汇总统计</span></div>
            <el-card v-loading="fetchStatisticsLoading" shadow="never" class="statistics-box">
                <el-row :gutter="20">
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.activityNum || 0}}</p><p class="color-info">演出总数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.amount || 0}}</p><p class="color-info">实际收入</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.orderNum || 0}}</p><p class="color-info">总订单数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.ticketNum || 0}}</p><p class="color-info">售票数</p></el-col>
                    <el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.discounts || '0.00'}}</p><p class="color-info">秀动承担优惠</p></el-col>
					<el-col :xs="12" :sm="8" :md="6" :lg="4"><p class="num">{{statistics.businessDiscounts || '0.00'}}</p><p class="color-info">B类承担优惠</p></el-col>
                </el-row>
            </el-card>
        </template>
        <div class="page-group-title"><span>统计列表</span></div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
               <el-table-column prop="activityId" label="演出ID" :min-width="150"></el-table-column>
               <el-table-column prop="activityName" label="演出名称" :min-width="150" show-overflow-tooltip></el-table-column>
			   <el-table-column prop="principalName" label="项目负责人"></el-table-column>
               <el-table-column prop="userName" label="艺人" :min-width="150" show-overflow-tooltip></el-table-column>
               <el-table-column prop="amount" label="实际收入" :min-width="150"></el-table-column>
               <el-table-column prop="orderNum" label="总订单数" :min-width="150"></el-table-column>
               <el-table-column prop="totalNum" label="售票数" :min-width="150"></el-table-column>
               <el-table-column prop="discounts" label="秀动承担优惠" :min-width="150"></el-table-column>
			   <el-table-column prop="businessDiscounts" label="B类承担优惠" :min-width="150"></el-table-column>
                <el-table-column label="操作" fixed="right" :width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="text" @click="toDate(scope.row)">查看日期明细</el-button>
						<el-button size="small" type="text" @click="toDashboard(scope.row.activityId)">渠道销售占比</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="pageSizeChange"
                @current-change="pageNoChange"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from './../../components/tab';
import dayjs from 'dayjs';
import {downloadFileTmp} from '@/assets/js/commonApi.js';

export default {
    components:{Tab},
    data(){
        const date = new Date();

        const month = date.getMonth();
        const day = date.getDate();

        const start = new Date();
        const end = new Date();

        start.setMonth(month - 12, day + 1);
        start.setHours(0, 0, 0);

        end.setHours(23, 59, 59);

        this.defaultParams = {
            searchType1: 1,
            searchName1: null,
            timeStart: dayjs(start).format('YYYY-MM-DD HH:mm:ss'),
            timeEnd: dayjs(end).format('YYYY-MM-DD HH:mm:ss'),
            sort: 1,
            pageNo: 1,
			timeType:1,
            pageSize: this.$pageSizes[0],
            showTypeTagIds:"",
            siteTypeTagIds: ""
        };

        const params = this.parsing();

        return{
            statistics: null,
            fetchStatisticsLoading: false,
            data: null,
            dataList: null,
            params: {...params},
            listLoading: false,
            filter: null,
            exportDataLoading: false,
            showTypeTagList: [],
            siteTypeTagList: []
        }
    },
    async created() {
        await this.getShowTypeTag();
        await this.getSiteTypeTag();
        this.$router.replace({
            path: '/report/sales/show', 
            query: {
                ...this.$route.query, 
                t: Date.now(),
                showTypeTagIds: this.params.showTypeTagIds.toString(), 
                siteTypeTagIds: this.params.siteTypeTagIds.toString()
            }
        });
        this.getStatistics();
    },
    watch: {
        '$route.query': function() {
            this.getDataList();
        }
    },
    methods:{
        parsing() {
            const {searchType1, searchName1, timeStart, timeEnd, sort, pageNo, pageSize, showTypeTagIds, siteTypeTagIds} = {...this.defaultParams, ...this.$route.query};

            return {
                searchType1: parseInt(searchType1), 
                searchName1, 
                time: timeStart && timeEnd ? [timeStart, timeEnd] : [], 
                sort: parseInt(sort), 
                pageNo: parseInt(pageNo), 
                pageSize: parseInt(pageSize),
				timeType:1,
                showTypeTagIds: showTypeTagIds ? (showTypeTagIds.split(',')).map(v => parseInt(v)) : [],
                siteTypeTagIds: siteTypeTagIds ? (siteTypeTagIds.split(',')).map(v => parseInt(v)) : []
            };
        },
        //获取活动类型
        getShowTypeTag(){
            return new Promise((resolve,reject) => {
                this.$request({
                    url: "/styleTag/showType/all",
                    method: "post",
                    // params: {id: this.id}
                }).then(res => {
                    const { state, result } = res.data;
                    if(state == 1){
                        this.showTypeTagList = result || []
                        if( this.params.showTypeTagIds.length == 0 ){
                            this.params.showTypeTagIds = [this.showTypeTagList[0].tags[0].id]
                        }
                    }
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        //获取场地类型
        getSiteTypeTag(){
            return new Promise((resolve,reject) => {
                this.$request({
                    url: "/styleTag/showType/site/all",
                    method: "post",
                }).then(res => {
                    const { state, result } = res.data;
                    if(state == 1){
                        this.siteTypeTagList = result || []
                        // if( !this.params.siteTypeTagIds ){
                        //     this.params.siteTypeTagIds = this.siteTypeTagList[0].id
                        // }
                    }
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                }) 
            })
        },
        //获取列表
        async getDataList() {
            const {time, ...params} = this.parsing();
            const [timeStart, timeEnd] = time || [];

            this.listLoading = true;

            const res = await this.$request({
                url: '/sales/activity/list',
                method: 'post',
                data: {...params, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];

            this.filter = {...params, timeStart, timeEnd};
        },
         //选择pageSize
        pageSizeChange() {
            if(this.isTimeError()) return;
            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/show', query: {...params, timeStart, timeEnd, t: Date.now(),showTypeTagIds: this.params.showTypeTagIds.toString(), 
                siteTypeTagIds: this.params.siteTypeTagIds.toString()}});
        },
        pageNoChange() {
            if(this.isTimeError()) return;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/show', query: {...params, timeStart, timeEnd, t: Date.now(),showTypeTagIds: this.params.showTypeTagIds.toString(), 
                siteTypeTagIds: this.params.siteTypeTagIds.toString()}});
        },
        //搜索
        search() {
            if(this.isTimeError()) return;
            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/show', query: {...params, timeStart, timeEnd, t: Date.now(),showTypeTagIds: this.params.showTypeTagIds.toString(), 
                siteTypeTagIds: this.params.siteTypeTagIds.toString()}});
            this.getStatistics();
        },
        //重置搜索
        reset() {
            const {timeStart, timeEnd, ...params} = this.defaultParams;
            this.params = {
                ...params,
                time: timeStart && timeEnd ? [timeStart, timeEnd] : [],
                showTypeTagIds: [],
                siteTypeTagIds: []
            };
            this.$router.replace({path: '/report/sales/show', query: {...params, timeStart, timeEnd, t: Date.now(),showTypeTagIds: this.params.showTypeTagIds.toString(), 
                siteTypeTagIds: this.params.siteTypeTagIds.toString()}});
            this.getStatistics();
        },
        isTimeError() {
            const {time} = this.params;
            const [timeStart, timeEnd] = time || [];

            // if(!timeStart || !timeEnd) {
            //     return false;
            // }
            if(!timeStart || !timeEnd) {
                this.$alert('请选择时间范围', '提示', {confirmButtonText: '确认', type: 'warning', center: true});
                return true;
            }

            if(new Date(timeEnd).getTime() - new Date(timeStart).getTime() > 730 * 24 * 60 *60 *1000) {
                this.$alert('目前支持查询最多2年的数据', '提示', {confirmButtonText: '确认', type: 'warning', center: true});
                return true;
            }

            return false;
        },
        async getStatistics() {
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];


            this.fetchStatisticsLoading = true;

            const res = await this.$request({
                url: '/sales/activity/statistics',
                method: 'post',
                data: {...params, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.fetchStatisticsLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.statistics = result || {};
        },
        // 导出
        async exportData() {
            const {filter} = this;

            if(!filter) {
                return this.$message.error('没有可以操作的数据');
            }

            this.exportDataLoading = true;

            const res = await this.$request({
                url:'/sales/activity/export',
                method: 'post',
                data: filter,
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.exportDataLoading = false;
            });

            const{state, msg, result} = res.data;
            
            if(state !== '1') {
                return this.$message.error(msg || '下载失败');
            }

            downloadFileTmp(result.url, '演出销售.xlsx');
        },
        // 查看图表
        async viewChart() {
            const {...filter} = this.filter;
            this.$router.push({path: '/report/sales/show/chart', query: {...filter}});
        },
        toDate(row) {
            const {activityId} = row;
            const {timeStart, timeEnd} = this.filter;
            this.$router.push({path: '/report/sales/show/date', query: {activityId, timeStart, timeEnd}});
        },
		//渠道销售占比
		toDashboard(id) {
			this.$router.push(`/activityManage/activity/edit/activityDashboard/${id}`)
		},
    }
}
</script>

<style lang="scss" scoped>
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>